// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_f7C","cls2":"Carousel-cls2_lRF Carousel-cls1_f7C"};